var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4609 3.75H11.7422L9.82812 1.99219C9.35938 1.52344 8.73438 1.25 8.07031 1.25H3.46094C2.05469 1.25 0.960938 2.38281 0.960938 3.75V16.25C0.960938 17.6562 2.05469 18.75 3.46094 18.75H18.4609C19.8281 18.75 20.9609 17.6562 20.9609 16.25V6.25C20.9609 4.88281 19.8672 3.75 18.4609 3.75ZM19.0859 16.25C19.0859 16.6016 18.7734 16.875 18.4609 16.875H3.46094C3.10938 16.875 2.83594 16.6016 2.83594 16.25V3.75C2.83594 3.4375 3.10938 3.125 3.46094 3.125H8.03125C8.1875 3.125 8.34375 3.20312 8.46094 3.32031L10.9609 5.625H18.4609C18.7734 5.625 19.0859 5.9375 19.0859 6.25V16.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.2e1b7ecb7e9b707458166790124ca39d.svg";
export { ForwardRef as ReactComponent };